import { ClickAwayListener } from '@mui/material';
import { gridClasses } from '@mui/x-data-grid-pro';
import { PropsWithChildren } from 'react';

type GridRowClickAwayListenerProps = {
  onClickAway: () => void;
};

export const GridRowClickAwayListener = ({
  children,
  onClickAway,
}: PropsWithChildren<GridRowClickAwayListenerProps>) => {
  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={(event) => {
        const target = event.target as HTMLElement;
        const isClickInsideRow = target.closest(`.${gridClasses.row}`) !== null;

        if (!isClickInsideRow) {
          onClickAway();
        }
      }}
    >
      <div>{children}</div>
    </ClickAwayListener>
  );
};
